import { html as t } from "@microsoft/fast-element";
import { startSlotTemplate as o, endSlotTemplate as l } from "@matrix42/fast-foundation";
const n = t`
  <div class="control" part="control">
    ${o({})}
    <span class="content" part="content">
      <slot></slot>
    </span>
    ${l({})}
  </div>
`;
export {
  n as badgeTemplate
};
